// FAQ.jsx
import React from 'react';
import { Container, Accordion } from 'react-bootstrap';
import './FAQ.css';

const FAQ = () => {
  const faqData = [
    {
      id: 1,
      question: "Чому я не бачу заявку в кабінеті батьків? При спробі додати нову пише що заявка вже зареєстрована",
      answer: "Заявка могла бути створена раніше з іншою електронною поштою або іншим профілем. Спробуйте відновити доступ до попереднього акаунта або зверніться в підтримку з номером свідоцтва про народження дитини."
    },
    {
      id: 2,
      question: "Я хочу потрапити саме в цей садок. Як правильно це зробити?",
      answer: "Додайте обраний садок першим у переліку бажаних під час подачі заявки. Ви можете додати декілька закладів та змінювати їх порядок у кабінеті батьків."
    },
    {
      id: 3,
      question: "Як обрати вікову категорію групи? Я хочу потрапити в групу 3-4 а мені показує 2-3.",
      answer: "Вікова група визначається автоматично за датою народження дитини на 1 вересня поточного року. Якщо є помилка у даті чи віці — перевірте дані в заявці."
    },
    {
      id: 4,
      question: "Коли мені прийде запрошення? Чому його досі немає?",
      answer: "За наявності у садочку, який Ви обрали, вільного місця, серед заяв автоматично обираються ті, які можуть його отримати за чергою. Діти, що записані у черзі перед Вами, можуть отримати запрошення і до інших закладів, тому черговість може змінюватися. Садочок може бути відкритим або закритим для надсилання запрошень на вільні місця. Стан «відкритий/закритий» та кількість місць визначає директор закладу. Вільні місця розраховуються автоматично як різниця між кількістю місць та дітей у групі. Запрошення надсилаються автоматично протягом всього року."
    },
    {
      id: 5,
      question: "Моя дитина вже відвідує садок. Як можна перейти до іншого?",
      answer: "Подайте нову заявку з позначкою «переведення» та оберіть бажані садочки. Після появи місця ви отримаєте запрошення."
    },
    {
      id: 6,
      question: "Що робити, якщо дитина не потрапить у садочок в цьому році?",
      answer: "Ви можете залишити заявку активною на наступний навчальний рік, змінити перелік бажаних садочків або звернутися до приватних закладів."
    },
    {
      id: 7,
      question: "Чи можна відхилити запрошення? Чи є в нас шанси потрапити до іншого садочку, якщо ми відмовимось від запрошення?",
      answer: "Так, ви можете відмовитися. У такому разі заявка знову братиме участь у розсиланні запрошень до інших садочків, якщо вони додані у переліку бажаних."
    },
    {
      id: 8,
      question: "Чи прийде запрошення після відмови?",
      answer: "Так, система продовжує розсилання нових запрошень за наявності місць та відповідно до черги і ваших налаштувань заяви."
    },
    {
      id: 9,
      question: "Яка найбільш поширена причина відмови?",
      answer: "Найчастіше — відсутність місць у вибраних садочках або невідповідність віковій групі. Рекомендуємо розширити перелік бажаних закладів."
    },
    {
      id: 10,
      question: "Чи можу я відмовитися і отримати нове запрошення?",
      answer: "Так. Після відмови заявка зберігає активний статус і може отримати інше запрошення відповідно до черги."
    },
    {
      id: 11,
      question: "Які наслідки відмови від запрошення?",
      answer: "Поточне запрошення анулюється, місце передається наступній дитині у черзі. Заявка продовжує участь у подальших розсиланнях."
    },
    {
      id: 12,
      question: "Чи можу я змінити дитячий садок після отримання запрошення?",
      answer: "Можете. Відмовтесь від чинного запрошення та відкоригуйте перелік бажаних садочків у кабінеті."
    },
    {
      id: 13,
      question: "Які документи потрібні для зміни садочка?",
      answer: "Свідоцтво про народження, медичні довідки, за потреби — документи про пільги. Точний перелік уточнюйте в адміністрації садочка."
    },
    {
      id: 14,
      question: "Як дізнатися про вільні місця в інших садочках?",
      answer: "Перевіряйте сторінки закладів на порталі та офіційні повідомлення Департаменту освіти. Дані про місця оновлюються протягом року."
    },
    {
      id: 15,
      question: "Чи є можливість переводу просто в середені навчального року?",
      answer: "Так, за наявності місць у бажаному закладі. Подайте заявку на переведення і дочекайтесь запрошення."
    },
    {
      id: 16,
      question: "На які критерії враховуються при подачі заявки в новий садочок?",
      answer: "Вік дитини, наявність пільг, дата подачі заявки та пріоритетність закладів у вашому списку."
    },
    {
      id: 17,
      question: "Які поради для підготовки дитини до нового садочка?",
      answer: "Поступово адаптуйте режим дня, відвідайте садок разом із дитиною, познайомтесь з вихователями, поясніть очікування."
    },
    {
      id: 18,
      question: "Чи можна віддати дитину в інший садок, якщо вона вже має друзів у поточному?",
      answer: "Так, рішення за батьками. Переведення здійснюється за стандартною процедурою за наявності місць у новому садочку."
    }
  ];

  return (
    <Container className="faq-container">
      <h1 className="page-title">Питання та відповіді</h1>

      <section className="faq-section">
        <Accordion defaultActiveKey="4">
          {faqData.map((item) => (
            <Accordion.Item key={item.id} eventKey={item.id.toString()} className="faq-item">
              <Accordion.Header className="faq-header">
                {item.question}
              </Accordion.Header>
              <Accordion.Body className="faq-body">
                {item.answer}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </section>
    </Container>
  );
};

export default FAQ;